// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storage-management {
    background-color: rgba(0, 0, 0, 0.3);
    height: 100%;
    width: 100%;
    z-index: 11;
    top: 0;
    left: 0;
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
}

.pop-up {
    width: 800px;
    height: 600px;
    border-radius: 10px;
    background-color: #FFFFFF;
}

.pop-up-header {
    padding: 2px 19px;
    font-size: 16px;
    display: flex;
    background-color: #1976D2;
    color: white;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    height: 50px;
    align-items: center;
    justify-content: space-between;
}

.pop-up-header span {
    font-size: 18px;
}

.pop-up-body {
    display: flex;
    height: 550px;
}

.pop-up-left-container {
    width: 25%;
    z-index: 1;
    height: 100%;
    background: #FFFFFF;
    border-bottom-left-radius: 10px;
    box-shadow: 0 4px 15px 0 rgba(119, 119, 119, 0.25);
}

.storage-band {
    height: 35%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.forq {
    display: flex;
    cursor: pointer;
    align-items: center;
}

.forq img {
    margin: 10px;
}

.forq span {
    width: 50%;
    font-size: 14px;
}

.forq p {
    color: #424242;
    margin: 0 10px;
    font-size: 10px;
    white-space: nowrap;
}

.pop-up-right-container {
    width: 75%;
    height: 100%;
    background: #F5F5F5;
    border-bottom-right-radius: 10px;
}

.right-header .back-arrow {
    width: 25px;
    height: 25px;
    display: flex;
    cursor: pointer;
    margin: 0 10px 0 0;
    align-items: center;
    border-radius: 100%;
    background: #0000001A;
    justify-content: center;
}

.right-header .back-arrow img {
    width: 12px;
}

.right-header {
    width: 95%;
    display: flex;
    margin: 10px auto;
    align-items: center;
    justify-content: space-between;
}

.right-header span {
    display: flex;
    color: #1976D2;
    font-size: 18px;
    overflow: hidden;
    white-space: nowrap;
    align-items: center;
    text-overflow: ellipsis;
}

.select-all {
    display: flex;
    width: fit-content;
    align-items: center;
    justify-content: end;
}

.select-all span {
    font-size: 14px;
}

.items-list {
    height: 88%;
    overflow: auto;
}

.items-list .item-row {
    width: 95%;
    height: 60px;
    display: flex;
    padding: 0 15px;
    cursor: pointer;
    align-items: center;
}

.item-row:hover {
    background-color: #FFFFFF;
}

.item-row span {
    font-size: 16px;
}

.item-row p {
    margin: 0;
    color: #4D4D4D;
    font-size: 12px;
}

.item-row img {
    width: 30px;
}

.bottom-buttons {
    display: flex;
    background-color: #FFFFFF;
    border-bottom-right-radius: 10px;
}

.bottom-buttons .footer-button {
    width: 100%;
    display: flex;
    color: #0048a4;
    padding: 15px 0;
    cursor: pointer;
    align-items: center;
    justify-content: center;
}

@media screen and (max-width: 600px) {

    .items-list {
        height: auto;
        flex-grow: 1;
        background-color: #FFFFFF;
    }

    .pop-up-right-container {
        width: 100%;
        height: 92%;
        display: flex;
        flex-direction: column;
    }

    .items-list .item-row {
        padding: 0;
        margin: auto;
    }

    .select-all {
        margin-right: 10px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/dashboard/css/storage-management-popup.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,YAAY;IACZ,WAAW;IACX,WAAW;IACX,MAAM;IACN,OAAO;IACP,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,4BAA4B;IAC5B,6BAA6B;IAC7B,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,+BAA+B;IAC/B,kDAAkD;AACtD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,eAAe;IACf,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;IAEI;QACI,YAAY;QACZ,YAAY;QACZ,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,WAAW;QACX,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".storage-management {\n    background-color: rgba(0, 0, 0, 0.3);\n    height: 100%;\n    width: 100%;\n    z-index: 11;\n    top: 0;\n    left: 0;\n    position: fixed;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 0;\n    padding: 0;\n}\n\n.pop-up {\n    width: 800px;\n    height: 600px;\n    border-radius: 10px;\n    background-color: #FFFFFF;\n}\n\n.pop-up-header {\n    padding: 2px 19px;\n    font-size: 16px;\n    display: flex;\n    background-color: #1976D2;\n    color: white;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n    height: 50px;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.pop-up-header span {\n    font-size: 18px;\n}\n\n.pop-up-body {\n    display: flex;\n    height: 550px;\n}\n\n.pop-up-left-container {\n    width: 25%;\n    z-index: 1;\n    height: 100%;\n    background: #FFFFFF;\n    border-bottom-left-radius: 10px;\n    box-shadow: 0 4px 15px 0 rgba(119, 119, 119, 0.25);\n}\n\n.storage-band {\n    height: 35%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.forq {\n    display: flex;\n    cursor: pointer;\n    align-items: center;\n}\n\n.forq img {\n    margin: 10px;\n}\n\n.forq span {\n    width: 50%;\n    font-size: 14px;\n}\n\n.forq p {\n    color: #424242;\n    margin: 0 10px;\n    font-size: 10px;\n    white-space: nowrap;\n}\n\n.pop-up-right-container {\n    width: 75%;\n    height: 100%;\n    background: #F5F5F5;\n    border-bottom-right-radius: 10px;\n}\n\n.right-header .back-arrow {\n    width: 25px;\n    height: 25px;\n    display: flex;\n    cursor: pointer;\n    margin: 0 10px 0 0;\n    align-items: center;\n    border-radius: 100%;\n    background: #0000001A;\n    justify-content: center;\n}\n\n.right-header .back-arrow img {\n    width: 12px;\n}\n\n.right-header {\n    width: 95%;\n    display: flex;\n    margin: 10px auto;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.right-header span {\n    display: flex;\n    color: #1976D2;\n    font-size: 18px;\n    overflow: hidden;\n    white-space: nowrap;\n    align-items: center;\n    text-overflow: ellipsis;\n}\n\n.select-all {\n    display: flex;\n    width: fit-content;\n    align-items: center;\n    justify-content: end;\n}\n\n.select-all span {\n    font-size: 14px;\n}\n\n.items-list {\n    height: 88%;\n    overflow: auto;\n}\n\n.items-list .item-row {\n    width: 95%;\n    height: 60px;\n    display: flex;\n    padding: 0 15px;\n    cursor: pointer;\n    align-items: center;\n}\n\n.item-row:hover {\n    background-color: #FFFFFF;\n}\n\n.item-row span {\n    font-size: 16px;\n}\n\n.item-row p {\n    margin: 0;\n    color: #4D4D4D;\n    font-size: 12px;\n}\n\n.item-row img {\n    width: 30px;\n}\n\n.bottom-buttons {\n    display: flex;\n    background-color: #FFFFFF;\n    border-bottom-right-radius: 10px;\n}\n\n.bottom-buttons .footer-button {\n    width: 100%;\n    display: flex;\n    color: #0048a4;\n    padding: 15px 0;\n    cursor: pointer;\n    align-items: center;\n    justify-content: center;\n}\n\n@media screen and (max-width: 600px) {\n\n    .items-list {\n        height: auto;\n        flex-grow: 1;\n        background-color: #FFFFFF;\n    }\n\n    .pop-up-right-container {\n        width: 100%;\n        height: 92%;\n        display: flex;\n        flex-direction: column;\n    }\n\n    .items-list .item-row {\n        padding: 0;\n        margin: auto;\n    }\n\n    .select-all {\n        margin-right: 10px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
